export const adaptTripMetadata = (metadata) => {
  const { marketingSubregionName } = metadata || { marketingSubregionName: 'Unknown' };
  return {
    marketingSubregionName: marketingSubregionName || 'Unknown',
  };
};
